import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "../../../../../src/Uri";
import { Container, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Textfield from "layouts/profile/GuestLoginForm/components/TextField";
import DateTimePicker from "../../../../layouts/profile/GuestLoginForm/components/DataTimePicker";
import Button from "layouts/profile/GuestLoginForm/components/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MDTypography from "components/MDTypography";
const useStyles = makeStyles({
  root: {
    height: 40,
  },
  size: {
    width: 40,
    height: 30,
  },
  gap: {
    paddingLeft: 20,
    height: 100,
  },
});
const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string()
    .matches(/^[aA-zZ\s]+$/, "Invalid Name ")
    .required("Required"),
  joiningDate: Yup.date().required("Required"),
  // .test(
  //   "DOB",
  //   "Please choose a valid date",
  //   (date) =>
  //     moment().diff(moment(date), "years") >= 12 &&
  //     moment().diff(moment(date), "years") <= 80
  // ),
  phoneNumber: Yup.string()
    .matches(/^[6-9]\d{9}$/, {
      message: "Please enter Valid Mobile Number",
      excludeEmptyString: false,
    })
    .required("Required"),
  advanceAmount: Yup.number().required("Required"),
  transactionId: Yup.string()
    .test(
      "len",
      "can be empty or with string at least 10 characters and not more than 30",
      (val) => {
        if (val == undefined) {
          return true;
        }
        return val.length == 0 || (val.length >= 10 && val.length <= 30);
      }
    )
    .required("Required"),
});
const Prebook = (props) => {
  const { guestdetails } = props;
  const [disableButtons, setDisableButtons] = React.useState(false);
  const [bookingStatus,setBookingStatus] = React.useState(false);
  useEffect(async()=>{
const res = await axios.get(`profiles/preBookBedId/${guestdetails.bedId}`)
res.data.body.preBookedStatus
setBookingStatus(res?.data?.body?.preBookedStatus)
  },[])
  const [INITIAL_FORM_STATE, setINITIAL_FORM_STATE] = React.useState({
    name: "",
    phoneNumber: "",
    joiningDate: "",
    advanceAmount: "",
    transactionId: "",
    buildingId: guestdetails.buildingId,
    bedId: guestdetails.bedId,
  });
  const classes = useStyles();
  return (
    <div>
       <MDTypography style={{ display: "flex" }}>
              You are prebooking the Bed{" "}
              <MDTypography
                color="success"
                fontWeight="bold"
                paddingLeft="10px"
              >
                {guestdetails.bedId}
              </MDTypography>
            </MDTypography>
            {
              bookingStatus?( 
                <MDTypography color="error"
                fontWeight="bold">This Bed is Already PreBooked</MDTypography>
             ):( <Formik
              initialValues={{ ...INITIAL_FORM_STATE }}
              validationSchema={FORM_VALIDATION}
              onSubmit={async (guest, { resetForm }) => {
                console.log(guest);
                // handleToggle();
                const res = await axios
                  // localhost:8989/profiles/addPreBook
                  .post("profiles/addPreBook/", guest);
                console.log(res);
                if (res.status === 200) {
                  props.editGuestHandler();
                  props.handleCloseGuestModalWindow();
                  toast.success("Booked successfully");
                } else {
                  toast.error("Server error");
                }
              }}
            >
              {(formProps) => (
                <Form>
                 
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <h5>Name*</h5>
                      <Textfield name="name" />
                    </Grid>
                    <Grid item xs={6}>
                      <h5>Joining Date*</h5>
                      <DateTimePicker
                        maxdate={new Date()}
                        name="joiningDate"
                        required
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <h5>Phone Number*</h5>
                      <Textfield name="phoneNumber" />
                    </Grid>
                    <Grid item xs={6}>
                      <h5>Amount *</h5>
                      <Textfield name="advanceAmount" required />
                    </Grid>
                    <Grid item xs={6}>
                      <h5>Transaction ID *</h5>
                      <Textfield name="transactionId" required />
                    </Grid>
                    <Grid item xs={6} sx={{ marginTop: 2 }}>
                      <Button
                        style={{ align: "center" }}
                        disabled={disableButtons}
                        onClick={() => {
                          setDisableButtons(true);
                        }}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                  <ToastContainer
                    maxWidth="sx"
                    position="top-right"
                    autoClose={3000}
                    type="toast.TYPE.SUCCESS"
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </Form>
              )}
            </Formik>)
            }
     
    </div>
  );
};

export default Prebook;
